












































































import { apiOrderWriteOffWriteOffDetail } from '@/api'
import { computed, nextTick, ref } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent, useQuery } from '@/hooks'
import { navigateTo } from '@/router'
import { submit, Track } from '@/utils'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '核销结果',
        }))
      }

      query = useQuery<{
        success: boolean
        message?: string
      }>({
        success: {
          transformer: value => value === 'true',
        },
      })

      isSuccess = computed(() => this.query.success)

      showInputVerifyDialog = ref(false)

      inputVerifyCode = ref('')

      // 扫码核销
      handleScanVerifyClick = async () => {
        const res = await dcb.scanCode({
          returnResult: true,
        })
        dcb.navigateTo({
          url: res.result!,
        })
      }

      // 券码核销
      handleInputVerifyClick = () => {
        this.showInputVerifyDialog.value = true
      }

      // 券码核销-取消
      handleInputVerifyCancelClick = () => {
        this.showInputVerifyDialog.value = false
      }

      // 券码核销-确认
      handleInputVerifyConfirmClick = () => {
        submit(async $ => {
          if (!this.inputVerifyCode.value) {
            return $.fail('请输入券码')
          }
          $.start()
          await apiOrderWriteOffWriteOffDetail({
            code: this.inputVerifyCode.value,
          })
          this.showInputVerifyDialog.value = false
          nextTick(() => {
            navigateTo('BookVerifyConfirm', {
              code: this.inputVerifyCode.value,
            })
            this.inputVerifyCode.value = ''
          })
        })
      }
    },
)
